//use of this component requires that you include jquery-ui.js on the page

'use strict';
var nowTemp = new Date();
var now = new Date(nowTemp.getFullYear(), nowTemp.getMonth(), nowTemp.getDate(), 0, 0, 0, 0);

module.exports = {
	setupDatePicker: function setupDatePicker() {
		window
			.jQuery('.datepicker')
			.datepicker({
				onRender: function (date) {
					return date.valueOf() < now.valueOf() ? 'disabled' : '';
				},
				dateFormat: 'yy-mm-dd',
				prevText: '<i class="fa fa-chevron-left"></i>',
				nextText: '<i class="fa fa-chevron-right"></i>'
			})
			.on('change');
	},

	setupClockPicker: function setupClockPicker() {
		window
			.jQuery('.clockpicker')
			.clockpicker({
				placement: 'bottom',
				donetext: 'Done'
			})
			.on('change', function () {
				var newVal = window.jQuery(this).val();
				var chunks = newVal.split(':');
				if (parseInt(chunks[0], 10) < 12) {
					window.jQuery(this).closest('.row').find('.amWarning').show();
				} else {
					window.jQuery(this).closest('.row').find('.amWarning').hide();
				}
			});
	},
	getDateString: function getDateString(date) {
		var dateString = '';
		if (date != null && date != '') {
			dateString = moment(date, 'DD-MMM-YYYY HH:mm:ss');
			dateString = dateString.format('YYYY-MM-DD');
		}
		return dateString;
	},

	getTimeString: function getTimeString(time) {
		var timeString = '';
		if (time != null && time != '') {
			timeString = moment(time, 'DD-MMM-YYYY HH:mm:ss');
			timeString = timeString.format('HH:mm');
		}
		return timeString;
	},

	toggleAMWarning: function toggleAMWarning(dateTimeField) {
		if (dateTimeField.val() != '') {
			var chunks = dateTimeField.val().split(':');
			if (parseInt(chunks[0], 10) < 12) {
				dateTimeField.closest('.row').find('.amWarning').show();
			} else {
				dateTimeField.closest('.row').find('.amWarning').hide();
			}
		}
	}
};
